<template>
  <v-row justify="center">
    <v-dialog
      v-model="deleteWorksCouncilDialogState"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Suppression de comité d'entreprise</span>
        </v-card-title>
        <v-container>
          <v-card-text>
            <p v-if="successMessage">
              <v-alert
                text
                dense
                color="teal"
                border="left"
                type="success"
              >
                {{ successMessage }}
              </v-alert>
            </p>

            <span v-if="worksCouncil">Etes-vous sûr de vouloir supprimer le comité d'entreprise ?</span>
          </v-card-text>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDeleteWorksCouncilDialog(false)"
          >
            Annuler
          </v-btn>

          <button
            type="button"
            :disabled="loading"
            class="v-btn v-btn--flat v-btn--text theme--light v-size--default blue--text text--darken-1"
            @click="deleteWorksCouncil(worksCouncil)"
          >
            <span class="v-btn__content">Valider</span>
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Vue from 'vue'
import config from '../../../config'

export default {
  name: 'DeleteWorksCouncilDialog',
  props: {
    worksCouncil: {
      type: Object,
      default: () => {
        return {}
      }
    },
    deleteWorksCouncilDialogState: Boolean
  },
  data: () => ({
    successMessage: null,
    loading: false,
    errors: []
  }),
  methods: {
    deleteWorksCouncil (worksCouncil) {
      this.loading = true

      Vue.prototype.$http
        .delete(config.apiUrl + '/api/works-councils/' + worksCouncil.id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 204) {
            this.successMessage = 'Le comité d\'entreprise a été supprimé.'
            this.errors = []
            this.closeDeleteWorksCouncilDialog(true)
          }

          this.loading = false
        })
        .catch(e => {
          this.loading = false

          const response = e.response

          if (response && response.status === 400) {
            const data = response.data
            this.errors = data.violations
            this.successMessage = null
          }

          if (response.status === 500) {
            this.errors.push({
              title: 'Une erreur est intervenue lors de la suppression du comité d\'entreprise.'
            })
          }
        })
    },
    closeDeleteWorksCouncilDialog (deleteState) {
      this.$emit('closeDeleteWorksCouncilDialog', deleteState)
    }
  }
}
</script>
